
<script>
import New from './New12'
import Edit from '../Edit'
export default {
  mixins: [New, Edit],
}
</script>
